import classNames from 'classnames';
import React from 'react';

export default function ButtonTab({ icon, title, active, onClick }) {
    return (
        <button
            type="button"
            className={classNames(
                'p-4 bg-white rounded-xl cursor-pointer transform duration-500 flex items-center gap-2 text-base w-max border border-[#DBDBDB]',
                'hover:shadow-lg hover:shadow-purple-PHX/20 hover:border-purple-PHX',
                'hover:font-semibold group',
                {
                    'hover:-translate-x-1': !active,
                    'shadow-lg shadow-purple-PHX/20 border border-purple-PHX font-semibold':
                        active,
                }
            )}
            onClick={onClick}
        >
            <span
                className={classNames(
                    'group-hover:text-purple-PHX duration-500 transition-all flex items-center',
                    { 'text-purple-PHX': active }
                )}
            >
                {icon}
            </span>
            <span>{title}</span>
        </button>
    );
}
